<template>
    <div id="content">
        <div class="container">

            <div id="leaderboard" class="card" style="height: calc(100vh - 190px);">
                <div class="card-body">
                    <h5 class="card-title">
                        <span class="title">{{ $t('leader_board') }}</span>

                        <button :class="'all_users' == filter_type ? 'btn btn-filter active' : 'btn btn-filter'"
                            @click="filter('all_users')">
                            <img src="/themes/ito/images/earth.svg" alt="" />
                            {{ $t('all') }}
                        </button>
                        <button :class="'school' == filter_type ? 'btn btn-filter active' : 'btn btn-filter'"
                            v-if="user_info.student_type == 1" @click="filter('school')">
                            <img src="/themes/ito/images/school.svg" alt="" />
                            {{ $t('school') }}
                        </button>
                        <div class="tools" style="width: 150px">
                            <div class="month-select">
                                <!-- <i class="ito-icon-next next" ></i> -->
                                <img @click="prev" src="/themes/ito/images/icons/icon-calander-prev.svg"
                                                            alt="">
                                <span class="text">{{ month_txt }} {{ year }}</span>

                                <img  @click="next" v-if="!isNextDisable()" src="/themes/ito/images/icons/icon-calander-next.svg" alt="">
                                <img v-else src="/themes/ito/images/icons/icon-calander-next-1.svg" alt="">
                                <!-- <i :class="isNextDisable() ? 'ito-icon-prev prev prev-disable' : 'ito-icon-prev prev'"
                                    @click="next"></i> -->
                            </div>
                        </div>
                    </h5>

                    <div class="card-content">
                        <div class="leader-board">
                            <div class="leader-board-column gem">
                                <div class="leader-board-content">
                                    <div class="leader-board-header">
                                        <h3>{{ $t('top_gems_leaders') }}</h3>
                                        <img src="/themes/ito/images/icon-gem-3.svg" alt="" />
                                    </div>
                                    <div class="leader-board-body">
                                        <div class="nano" v-if="leaderboards.length > 0">
                                            <div class="nano-content d-flex flex-column gap-2">
                                                <div class="leader-board-item" v-for="(user, index) in leaderboards">
                                                    <div class="d-flex gap-3">
                                                        <div class="numb">
                                                            <img :src="getLevelUrl(index)" alt="" v-if="index <= 2" />
                                                            <span v-else>{{ index + 1 }}</span>
                                                        </div>
                                                        <div class="avatar">
                                                            <img class="img-fluid" :src="user.avatar_url" alt=""
                                                                v-if="user.avatar_url" />
                                                            <img class="img-fluid"
                                                                src="/themes/ito/images/avatar-default.svg" alt="" v-else />
                                                            <span class="emotion" v-if="user.emoji_url">
                                                                <img class="img-fluid" :src="user.emoji_url" alt="">
                                                            </span>
                                                        </div>
                                                        <div class="info">
                                                            {{ user.fullname || user.username }}
                                                            <small>{{ user.username }}</small>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex gap-3">
                                                        <div class="value">
                                                            {{ user.gem || user.username }}
                                                            <img style="width: 20px;" src="/themes/ito/images/icon-gem-3.svg" alt="" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="leaderboard-empty-txt" v-else>
                                            {{ $t('no_leader_board') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="leader-board-footer" v-if="leaderboards.length > 0">
                                    <div class="leader-board-item" v-if="my_rank && my_rank.rank != 0">
                                        <div class="d-flex gap-3 align-items-center">
                                            <div class="numb">
                                                {{ my_rank.rank }}
                                            </div>
                                            <div class="avatar">
                                                <img class="img-fluid" :src="my_rank.avatar_url" alt=""
                                                    v-if="my_rank.avatar_url" />
                                                <img class="img-fluid" src="/themes/ito/images/avatar-default.svg" alt=""
                                                    v-else />
                                                <span class="emotion" v-if="my_rank.emoji_url">
                                                    <img class="img-fluid" :src="my_rank.emoji_url" alt="">
                                                </span>
                                            </div>
                                            <div class="info">
                                                {{ my_rank.fullname || my_rank.username }}
                                            </div>
                                        </div>
                                        <div class="d-flex gap-3 align-items-center">
                                            <div class="value">
                                                {{ my_rank.gem | toCommas }}
                                                <img style="width: 20px;" src="/themes/ito/images/icon-gem-3.svg" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="leader-board-item no-rank" v-else>
                                        <p><b>{{ $t('you_not_rated') }}</b></p>
                                        {{ $t('leader_board_not_rated_gem_desc') }}
                                    </div>
                                </div>
                            </div>
                            <div class="leader-board-column crown">
                                <div class="leader-board-content">
                                    <div class="leader-board-header">
                                        <h3>{{ $t('top_crowns_leaders') }}</h3>
                                        <img src="/themes/ito/images/icon-crown-3.svg" alt="" />
                                    </div>
                                    <div class="leader-board-body">
                                        <div class="nano" v-if="crown_leaderboards.length > 0">
                                            <div class="nano-content d-flex flex-column gap-2">
                                                <div class="leader-board-item" v-for="(user, index) in crown_leaderboards">
                                                    <div class="d-flex gap-3">
                                                        <div class="numb">
                                                            <img :src="getLevelUrl(index)" alt="" v-if="index <= 2" />
                                                            <span v-else>{{ index + 1 }}</span>
                                                        </div>
                                                        <div class="avatar">
                                                            <img class="img-fluid" :src="user.avatar_url" alt=""
                                                                v-if="user.avatar_url" />
                                                            <img class="img-fluid"
                                                                src="/themes/ito/images/avatar-default.svg" alt="" v-else />
                                                            <span class="emotion" v-if="user.emoji_url">
                                                                <img class="img-fluid" :src="user.emoji_url" alt="">
                                                            </span>
                                                        </div>
                                                        <div class="info">
                                                            {{ user.fullname || user.username }}
                                                            <small>{{ user.username }}</small>
                                                        </div>
                                                    </div>
                                                    <div class="d-flex gap-3">
                                                        <div class="value">
                                                            {{ user.gem || user.username }}
                                                            <img style="width: 20px;" src="/themes/ito/images/icon-crown-3.svg" alt="" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="leaderboard-empty-txt" v-else>
                                            {{ $t('no_leader_board') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="leader-board-footer" v-if="crown_leaderboards.length > 0">
                                    <div class="leader-board-item" v-if="crown_my_rank && crown_my_rank.rank != 0">
                                        <div class="d-flex gap-3 align-items-center">
                                            <div class="numb">
                                                {{ crown_my_rank.rank }}
                                            </div>
                                            <div class="avatar">
                                                <img class="img-fluid" :src="crown_my_rank.avatar_url" alt=""
                                                    v-if="crown_my_rank.avatar_url" />
                                                <img class="img-fluid" src="/themes/ito/images/avatar-default.svg" alt=""
                                                    v-else />
                                                <span class="emotion" v-if="crown_my_rank.emoji_url">
                                                    <img class="img-fluid" :src="crown_my_rank.emoji_url" alt="">
                                                </span>
                                            </div>
                                            <div class="info">
                                                {{ crown_my_rank.fullname || crown_my_rank.username }}
                                            </div>
                                        </div>
                                        <div class="d-flex gap-3 align-items-center">
                                            <div class="value">
                                                {{ crown_my_rank.gem | toCommas }}
                                                <img style="width: 20px;" src="/themes/ito/images/icon-crown-3.svg" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="leader-board-item no-rank" v-else>
                                        <p><b>{{ $t('you_not_rated') }}</b></p>
                                        {{ $t('leader_board_not_rated_crown_desc') }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from "axios";
import { getLeaderboard } from "../../models/leadboard";

export default {
    name: "LeaderBoard",
    title: 'Leaderboard',

    data() {
        const d = new Date();
        const months = [
            this.$i18n.t('jan'),
            this.$i18n.t('feb'),
            this.$i18n.t('mar'),
            this.$i18n.t('apr'),
            this.$i18n.t('may'),
            this.$i18n.t('jun'),
            this.$i18n.t('jul'),
            this.$i18n.t('aug'),
            this.$i18n.t('sep'),
            this.$i18n.t('oct'),
            this.$i18n.t('nov'),
            this.$i18n.t('dec')
        ];
        const month = this.$route.query.month || d.getMonth() + 1;
        const year = this.$route.query.year || d.getFullYear();

        return {
            leaderboards: [],
            my_rank: null,
            crown_leaderboards: [],
            crown_my_rank: null,
            year: year,
            months: months,
            month: month,
            month_txt: months[month - 1],
            filter_type: 'all_users'
        };
    },

    computed: {
        ...mapGetters([
            'user_info'
        ], () => {
            if (this.user_info) {
                return this.user_info
            }

            return this.user
        })
    },

    watch: {
        $route() {
            this.fetch()
        }
    },

    created() {
        this.$store.commit("setMenuActive", "home");
        this.fetch();
    },

    methods: {
        fetch() {
            this.getData()
        },

        getLevelUrl(index) {
            const file_name_index = index + 1;
            return '/themes/ito/images/lb-level-' + file_name_index + '.svg'
        },

        isNextDisable() {
            const that = this;
            const date = new Date();
            const current_month = date.getMonth() + 1;
            const current_year = date.getFullYear();
            const year_next = that.month == 12 ? parseInt(that.year) + 1 : that.year;
            const month_next = that.month == 12 ? 1 : parseInt(that.month) + 1;

            if (current_year == year_next && current_month < month_next || current_year < year_next) {
                return true;
            }

            return false;
        },
        getData() {
            let that = this;
            that.$store.commit("setLoading", true);
            axios.all([
                getLeaderboard({
                    grade: that.user_info.grade,
                    school: that.filter_type == 'all_users' ? 0 : 1,
                    year: that.year,
                    month: that.month
                }),
            ]).then(axios.spread((response) => {
                that.$store.commit("setLoading", false);

                if (response.data.code != 0) {
                    return;
                }

                that.leaderboards = response.data.results.gem.leaderboard || [];
                that.my_rank = response.data.results.gem.my_rank || null;

                that.crown_leaderboards = response.data.results.crown.leaderboard || [];
                that.crown_my_rank = response.data.results.crown.my_rank || null;

                that.month_txt = that.months[that.month - 1];

                that.$nextTick(function () {
                    initNanoScroller();
                })
            }));
        },

        next() {
            const that = this;
            const date = new Date();
            const current_month = date.getMonth() + 1;
            const current_year = date.getFullYear();
            const year_next = that.month == 12 ? parseInt(that.year) + 1 : that.year;
            const month_next = that.month == 12 ? 1 : parseInt(that.month) + 1;

            if (current_year == year_next && current_month < month_next) {
                return;
            }
            that.year = year_next;
            that.month = month_next;
            this.getData();

        },

        prev() {
            const that = this;
            const year_prev = that.month == 1 ? parseInt(that.year) - 1 : that.year;
            const month_prev = that.month == 1 ? 12 : parseInt(that.month) - 1;

            that.year = year_prev;
            that.month = month_prev;
            this.getData();
        },

        filter(type) {
            this.filter_type = type;
            this.getData();
        }
    }
}
</script>

<style scoped>
.title{
    flex: 1;
}
.card-title{
    color: #000000;
    display: flex;
    align-items: center;
}
.board-list-empty {
    margin: auto;
    text-align: center;
}

/*.level-items.top10 {
        height: 430px;
        overflow: auto;
    }*/

.level-items.top10::-webkit-scrollbar,
.level-items.top10::-webkit-scrollbar-thumb {
    width: 26px;
    border-radius: 13px;
    background-clip: padding-box;
    border: 10px solid transparent;
}

.level-items.top10::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 0 10px;
}

.level-items.top10:hover {
    color: rgba(0, 0, 0, 0.3);
}

#leaderboard .board>.board-left .row3 .board-right-message {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    color: #000000;
    padding: 15px 5px;
}

#leaderboard .board>.board-left .row3 .board-right-message b {
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: #000000;
}
.card-content {
    height: calc(100% - 65px);
}

.leader-board {
    display: flex;
    width: 100%;
    height: 100%;
    gap: 20px;
    justify-content: space-between;
}

.leader-board .leader-board-column {
    display: flex;
    width: 50%;
    flex-direction: column;
    justify-content: space-between;
    background: #F5F5F5;
    border-radius: 8px;
    height: 100%;
    overflow: hidden;
}

.leader-board .leader-board-column .leader-board-content {
    display: flex;
    flex-direction: column;
    height: 100%;
}


.leader-board .leader-board-column .leader-board-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 20px;
    line-height: 27px;
}

.leader-board .gem .leader-board-header {
    background: #7F85E0;
}

.leader-board .crown .leader-board-header {
    background: rgb(153, 202, 62);
}

.leader-board .leader-board-column .leader-board-header h3 {
    margin: 0;
    font-weight: 700;
    font-size: 20px;
    color: #FFFFFF;

}

.leader-board .leader-board-column .leader-board-body {
    height: 100%;
    padding: 8px 10px;
}

.leaderboard-empty-txt {
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    color: #828282;
    padding-top: 30px;
    text-align: center;
}

.leader-board-item {
    display: flex;
    gap: 1rem;
    align-items: center;
    justify-content: space-between;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 8px 17px;
    height: 60px;
    width: 100%;
    color: #000000;
}

.leader-board-item .numb {
    width: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.leader-board-footer .leader-board-item .numb {
    width: unset;
    padding: 0 9px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: inset 0px 2px 0px rgba(255, 255, 255, 0.2);
    border-radius: 30px;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 24px;
    color: #6A6C7E;
    text-align: center;
}

.leader-board-item .numb span {
    font-weight: 700;
    font-size: 14px;
    text-align: center;
    color: #000000;
}

.leader-board-item .avatar {
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

.leader-board-footer .leader-board-item .avatar {
    width: 43px;
    height: 43px;
}

.leader-board-item .avatar .emotion {
    position: absolute;
    bottom: -3px;
    right: -3px;
    width: 23px;
    height: 23px;
    border: 3px solid #FFFFFF;
    border-radius: 90em;
}

.leader-board-item .info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    font-style: normal;
    letter-spacing: 0.02em;
    padding: 0 13px;
    text-align: initial;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 700;
    font-size: 14px;
    line-height: 19px;
    color: #0D0D0C;
    font-weight: 700;
    color: #000000;
}

.leader-board-footer .leader-board-item .info {
    font-size: 16px;
}

.leader-board-item .info small {
    font-weight: 400;
    font-size: 10px;
    line-height: 14px;
    color: #000000;
    display: block;
    margin-top: 2px;
}

.leader-board-item .value {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.5rem;
    font-weight: 700;
    font-size: 20px;
    letter-spacing: 0.02em;
    color: #6A6C7E;
}

.leader-board-footer .leader-board-item .value {
    font-size: 14px;
}

.leader-board .leader-board-column .leader-board-footer {
    background: #E1E1E1;
    border-radius: 0;
    padding: 8px 10px;
}
.leader-board .leader-board-column .leader-board-footer .leader-board-item.no-rank {
    gap: 0;
    flex-direction: column;
}

.tools .month-select {
    display: flex;
    align-items: center;
    width: 150px;
    background: #FFFFFF;
    border-radius: 8px;
    padding: 10px 11px;
}
.tools .month-select img{
    cursor: pointer;
}

.tools .month-select .next {
    cursor: pointer;
}

.tools .month-select .text {
    flex: 1;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    font-feature-settings: 'tnum' on, 'lnum' on;
    color: #000000;
    text-align: center;
    text-transform: capitalize;
}

.tools .month-select .prev {
    cursor: pointer;
}

.tools .month-select a {
    line-height: 10px;
}

.btn-filter-users {
    background: rgba(0, 163, 255, 0.82);
    border-radius: 8px;
    padding: 5px 12px;
    font-weight: 700;
    font-size: 14px;
    line-height: 19px;
    color: #FFFFFF;
    margin-right: 12px;
}

.btn-filter-users>img {
    margin-right: 8px;
}

.btn-filter-school {
    background: #FFFFFF;
    border-radius: 8px;
    padding: 5px 12px;
    font-weight: 700;
    font-size: 14px;
    line-height: 19px;
    color: #000000;
    margin-right: 12px;
}

.btn-filter {
    background: #FFFFFF;
    border-radius: 8px;
    padding: 5px 12px;
    font-weight: 700;
    font-size: 14px;
    line-height: 19px;
    color: #000000;
    margin-right: 12px;
}

.btn-filter.active {
    background: rgba(0, 163, 255, 0.82);
    border-radius: 8px;
    padding: 5px 12px;
    font-weight: 700;
    font-size: 14px;
    line-height: 19px;
    color: #FFFFFF;
    margin-right: 12px;
}

.btn-filter-school>img {
    margin-right: 8px;
}
</style>
